import React from 'react';

import { SearchContext } from './search-context';
import AccessibleElement from '../../ui/components/accessible-element';
import FacetCheckbox from './facet-checkbox';
import Icon from '../../ui/components/icon';
import Tooltip from '../../shared/components/tooltip';

export default class SearchRatingFilter extends React.Component {
    static defaultProps = {
        options: ['5', '4', '3', '2', '1', '0'],
    };

    constructor(props) {
        super(props);
        this.state = {
            expand: props.defaultExpanded,
        };
    }

    handleChange = (updateQuery, value) => e => {
        const { field } = this.props;
        updateQuery('replace', { [`${field}`]: value });
    };

    toggleMenu = () => {
        this.setState({
            expand: !this.state.expand,
        });
    };

    /**
     * Assumes ratings are a keyed range filter aggregation
     */
    mapAggregation = aggs => {
        const { options, field } = this.props;
        let fieldAgg = aggs[field] && (aggs[field][`${field}_filtered`] || aggs[field]);
        let { buckets = {} } = fieldAgg || {};
        return options.reduce((r, k) => {
            let bucketKey = k === '0' ? '*-0.0' : `${k}.0-*`;
            r[k] = (buckets[bucketKey] || {}).doc_count;
            return r;
        }, {});
    };

    render() {
        let { displayName, format, field, options, CustomFilterOption, onFilterClick, metricsId, description } = this.props;

        return (
            <SearchContext.Consumer>
                {({ updateQuery, query, aggregations }) => {
                    let bucketMap = this.mapAggregation(aggregations);
                    return (
                        <div className={`filter-group${this.state.expand ? ' expanded' : ' closed'}`} key="ratings">
                            <AccessibleElement
                                element="h3"
                                className="filter-header"
                                ariaLabel={displayName}
                                onClick={this.toggleMenu}
                            >
                                {description && (
                                    <Tooltip ariaLabel={description} displayOn="click">
                                        {description}
                                    </Tooltip>
                                )}
                                {displayName}
                                <span className="arrow"></span>
                                <Icon name={this.state.expand ? 'minus_m' : 'plus'} size={20} />
                            </AccessibleElement>
                            <ul className="facet-values">
                                {CustomFilterOption ? (
                                    <CustomFilterOption
                                        options={options}
                                        filterName={displayName}
                                        field={field}
                                        onClick={updateQuery}
                                        onFilterClick={onFilterClick}
                                        metricsId={metricsId}
                                    />
                                ) : (
                                    options.map(r => {
                                        const displayName = r !== '0' ? `${r} Stars & up` : 'None';
                                        const type = 'rating';
                                        const selected = query[field] && query[field].includes(r);
                                        return (
                                            <li className={`facet-value facet-${type}`} key={r}>
                                                <div
                                                    className={'facet-value-detail'}
                                                    onClick={this.handleChange(updateQuery, r)}
                                                >
                                                    <FacetCheckbox
                                                        type={type}
                                                        selected={selected}
                                                        displayName={displayName}
                                                        count={bucketMap[r]}
                                                        value={r}
                                                    />
                                                </div>
                                            </li>
                                        );
                                    })
                                )}
                            </ul>
                        </div>
                    );
                }}
            </SearchContext.Consumer>
        );
    }
}
